(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-shopping-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.getElementById('product-grid-redesign');
    const categoryButtons = document.querySelectorAll('.category-button');
    const categorySlotsContainers = document.querySelectorAll('.category-slots');
    const availableItemsTitle = document.querySelector('#tagged-products-column h2'); // Get the title element

    let currentCollectionHandle = '';
    let boardItems = {
      cheese: [],
      meats: [],
      crackers: [],
      spreads_jams: [],
      else: []
    };
    const maxSlotsPerCategory = 3;

   function updateBoardDisplay() {
    for (const category in boardItems) {
    const slotsContainer = document.querySelector(`.category-slots[data-category="${category}"]`);
    const slots = slotsContainer.querySelectorAll('.board-slot');

    slots.forEach((slot, index) => {
      if (boardItems[category][index]) {
        const item = boardItems[category][index];
        slot.classList.remove('empty');
        slot.classList.add('filled');
        slot.innerHTML = `
          <div class="slot-image-wrapper">
            <img src="${item.image}" alt="${item.title}">
          </div>
          <div class="slot-details">
            <div class="slot-title">${item.title}</div>
            <div class="slot-price">${item.price}</div>
          </div>
          <button class="remove-from-board" data-category="${category}" data-index="${index}">×</button>
        `;
      } else {
        slot.classList.remove('filled');
        slot.classList.add('empty');
        slot.innerHTML = `<span>${category.charAt(0).toUpperCase() + category.slice(1)} ${index + 1}</span>`;
      }
    });
  }
  attachRemoveFromBoardListeners(); // Call the new listener function
  console.log('Your Board Items:', boardItems);
}
function addNewSlot(category) {
  console.log('addNewSlot called for:', category);
  const slotsContainer = document.querySelector(`.category-slots[data-category="${category}"]`);
  console.log('slotsContainer found:', slotsContainer);
  if (slotsContainer) {
    const existingSlots = slotsContainer.querySelectorAll('.board-slot');
    const nextSlotNumber = existingSlots.length + 1;
    const newSlot = document.createElement('div');
    newSlot.classList.add('board-slot', 'empty');
    newSlot.dataset.slot = nextSlotNumber;
    newSlot.innerHTML = `<span>${category.charAt(0).toUpperCase() + category.slice(1).replace('_jams', ' & Jams')} ${nextSlotNumber}</span>`;
    slotsContainer.appendChild(newSlot);
    console.log('New slot added');
  } else {
    console.log('Error: slotsContainer NOT found for:', category);
  }
}

const addSlotButtons = document.querySelectorAll('.add-slot-button-below');
console.log('Number of addSlotButtons found:', addSlotButtons.length); // ADD THIS LINE
addSlotButtons.forEach(button => {
  button.addEventListener('click', function() {
    const categoryToAddSlot = this.dataset.category;
    console.log('Add Slot button clicked for category:', categoryToAddSlot); // ADD THIS LINE
    addNewSlot(categoryToAddSlot);
  });
});
function attachRemoveFromBoardListeners() {
  const removeButtons = document.querySelectorAll('.remove-from-board');
  removeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const categoryToRemove = this.dataset.category;
      const indexToRemove = parseInt(this.dataset.index);

      if (boardItems[categoryToRemove] && boardItems[categoryToRemove][indexToRemove]) {
        boardItems[categoryToRemove].splice(indexToRemove, 1); // Remove the item from the array
        updateBoardDisplay(); // Re-render the board
      }
    });
  });
}
    function attachAddToBoardListeners() {
      const addToBoardButtons = document.querySelectorAll('.add-to-board');
      addToBoardButtons.forEach(button => {
        button.addEventListener('click', function() {
          const productHandle = this.dataset.productHandle;
          const productTitle = this.dataset.productTitle;
          const productPrice = this.dataset.productPrice;
          const productImage = this.dataset.productImage;
          const productCategory = this.dataset.productCategory;

          if (boardItems[productCategory].length < maxSlotsPerCategory) {
            boardItems[productCategory].push({ handle: productHandle, title: productTitle, price: productPrice, image: productImage });
            updateBoardDisplay();
          } else {
            alert(`The ${productCategory} section is full.`);
          }
        });
      });
    }

   function displayProducts(collectionHandle, categoryName) {
  productGrid.innerHTML = 'Loading products...';
  currentCollectionHandle = collectionHandle;

  if (collectionHandle) {
    fetch(`/collections/${collectionHandle}/products.json?limit=50`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log(`Fetched products for ${collectionHandle}:`, data.products);
        if (data && data.products) {
          productGrid.innerHTML = '';
         data.products.forEach(product => {
    console.log('Full Product Object:', product); // Keep this for now for debugging

    const altText = product.featured_image ? product.featured_image.alt : product.title;
    let imageUrl = '';

    if (product.images && product.images.length > 0 && product.images[0].src) {
      // Use the src of the first image in the images array
      imageUrl = product.images[0].src;
      console.log('Image URL from product.images:', imageUrl);
    } else {
      console.log('No image URL found for:', product.title);
    }

    const productCategory = Array.from(categoryButtons).find(button => button.dataset.collection === collectionHandle)?.dataset.category || 'else';

    const productItem = document.createElement('div');
    productItem.classList.add('product-item');
    productItem.innerHTML = `
      <div class="product-item__image-wrapper">
        ${imageUrl ? `
          <div class="media media--transparent" style="--ratio-percent: 100%; position: relative; min-height: 200px;">
            <img
              src="${imageUrl}?width=300"
              alt="${altText ? altText.replace(/"/g, '&quot;') : product.title.replace(/"/g, '&quot;')}"
              style="width: 100%; height: auto; object-fit: cover; object-position: center 20%;"
              loading="lazy"
            >
          </div>
        ` : 'No Image Available'}
      </div>
      <div class="product-item__info">
        <div class="product-item__title-and-rating">
          <h3 class="product-item__title">${product.title}</h3>
          <div class="klaviyo-star-rating-widget" data-id="${product.id}" data-product-title="${product.title}" data-product-type="${product.type}"></div>
        </div>
        <p class="price">${product.price}</p>
      </div>
      <button class="add-to-board"
              data-product-handle="${product.handle}"
              data-product-title="${product.title}"
              data-product-price="${product.price}"
              data-product-image="${imageUrl ? imageUrl + '?width=50' : ''}"
              data-product-category="${productCategory}">Add to Board</button>
    `;
    productGrid.appendChild(productItem);
  });

          attachAddToBoardListeners();
        } else {
          productGrid.textContent = `No products found in this collection.`;
        }
      })
      .catch(error => {
        console.error('Error fetching products:', error);
        productGrid.textContent = 'Error loading products.';
      });
  } else {
    productGrid.textContent = 'Please select a category.';
  }

  // Update the left column title
  availableItemsTitle.textContent = `Available ${categoryName}`;
}

    categoryButtons.forEach(button => {
      button.addEventListener('click', function() {
        categoryButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        const collectionHandle = this.dataset.collection;
        const categoryName = this.dataset.category.charAt(0).toUpperCase() + this.dataset.category.slice(1); // Capitalize category name
        displayProducts(collectionHandle, categoryName); // Pass category name

        // Show the slots for the clicked category and hide others
        categorySlotsContainers.forEach(container => {
          container.style.display = 'none';
        });
        const currentSlotsContainer = document.querySelector(`.category-slots[data-category="${this.dataset.category}"]`);
        if (currentSlotsContainer) {
          currentSlotsContainer.style.display = 'block';
        }
      });
    });

    // Initial load - display the 'cheese' collection and slots
    const initialCheeseButton = document.querySelector('.category-button[data-category="cheese"]');
    if (initialCheeseButton) {
      initialCheeseButton.click();
      const initialCheeseSlots = document.querySelector('.category-slots[data-category="cheese"]');
      if (initialCheeseSlots) {
        initialCheeseSlots.style.display = 'block';
      }
      availableItemsTitle.textContent = 'Available Cheeses'; // Set initial title
    }

    updateBoardDisplay(); // Initial display of empty board with correct labels
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-info-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const guestCountSelect = document.getElementById('guest-count');
    const deliveryDateInput = document.getElementById('delivery-date');
    const submitButton = document.getElementById('submit-customer-info');

    // Set the minimum date to one week from today
    const today = new Date();
    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);
    const year = nextWeek.getFullYear();
    const month = String(nextWeek.getMonth() + 1).padStart(2, '0');
    const day = String(nextWeek.getDate()).padStart(2, '0');
    deliveryDateInput.min = `${year}-${month}-${day}`;

    submitButton.addEventListener('click', () => {
      const guestCount = guestCountSelect.value;
      const deliveryDate = deliveryDateInput.value;
      const allergies = document.getElementById('allergies').value;

      const customerInfo = {
        guestCount: guestCount,
        deliveryDate: deliveryDate,
        allergies: allergies
      };

      console.log('Customer Info:', customerInfo); // For testing

      // Dispatch a custom event with the guest count information
      const guestCountUpdatedEvent = new CustomEvent('guestCountUpdated', { detail: { guestCount: guestCount } });
      window.dispatchEvent(guestCountUpdatedEvent); // Dispatch event on button click

      const recommendationSection = document.getElementById('customizer-recommendations');
      if (recommendationSection) {
        recommendationSection.dataset.guestCount = guestCount;
        recommendationSection.dataset.deliveryDate = deliveryDate;
        recommendationSection.dataset.allergies = allergies;

        const updateRecommendationsEvent = new CustomEvent('customerInfoUpdated', { detail: customerInfo });
        window.dispatchEvent(updateRecommendationsEvent);
      }
    });

    // Optionally, dispatch the event on initial load if there's a default value
    if (guestCountSelect.value) {
      const initialGuestCountEvent = new CustomEvent('guestCountUpdated', { detail: { guestCount: guestCountSelect.value } });
      window.dispatchEvent(initialGuestCountEvent);
    }

    // Remove the event listener for 'change' to only update on button click
    // guestCountSelect.addEventListener('change', () => {
    //   const currentGuestCount = guestCountSelect.value;
    //   const guestCountChangedEvent = new CustomEvent('guestCountUpdated', { detail: { guestCount: currentGuestCount } });
    //   window.dispatchEvent(guestCountChangedEvent);
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Optimize resize listener using a debouncer rather than an instant re-bind wrapper
      let resizeTimeout;
      this.resizeObserver = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => this.setHeaderHeight(), 100);
      };
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.resizeObserver);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Cache disclosures and search elements immediately to prevent DOM-searching on scroll frames
      this.disclosures = this.header.querySelectorAll('header-menu');
      this.searchModal = this.header.querySelector('details-modal');

      // Performance Optimization: Tracking variables for animation frames
      this.ticking = false;
      this.onScrollHandler = this.onScrollThrottle.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true }); // passive: true improves touch/scroll response dramatically

      this.createObserver();
    }

    setHeaderHeight() {
      // Wrap style update in requestAnimationFrame to protect the paint cycle
      requestAnimationFrame(() => {
        if (this.header) {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.matchMedia('(max-width: 990px)').removeEventListener('change', this.resizeObserver);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    // Optimization: Throttles down incoming scroll triggers using the browser's native frame clock
    onScrollThrottle() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.onScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) {
          this.hide();
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      // Batch layout mutations cleanly
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.disclosures) return;
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
